/* The Hollow Harvest · la pagina del registro disegnata sul posto
   Tutto avviene dentro il canvas del visitatore: nessuna richiesta, nessun
   nome che parte, niente da salvare. Se qualcosa va storto (font che non
   carica, un errore imprevisto) la pagina resta un foglio di carta leggibile,
   mai un riquadro rotto: vedi il fondo CSS di riserva in hh-s-ledger.css e i
   try/catch qui sotto. */

(function () {
  'use strict';

  /* ---------------------------------------------------------- token ---- */
  /* Solo i sei colori concessi. Nessun grigio freddo, nessun colore nuovo.
     L'inchiostro è sempre soot: il "muto" si ottiene con globalAlpha, mai
     con un altro hex. */
  var INK = 'rgb(22, 17, 12)';        // --soot
  var PAPER = 'rgb(232, 220, 196)';   // --paper
  var PAPER_DEEP = 'rgb(213, 195, 161)'; // --paper-deep
  var WHEAT = 'rgb(185, 150, 63)';    // --wheat

  var F_DISPLAY = '"IM Fell English SC", "Iowan Old Style", Georgia, serif';
  var F_BODY = '"EB Garamond", "Palatino Linotype", "Book Antiqua", serif';

  /* La pagina è disegnata in uno spazio logico fisso (1000x1250, un 4:5:
     il formato che si legge intero in qualunque chat) e poi scalata per
     schermi ad alta densità: tutte le coordinate qui sotto sono logiche. */
  var LOGICAL_W = 1000;
  var LOGICAL_H = 1250;
  var DPR = Math.max(1, Math.min(window.devicePixelRatio || 1, 2));

  /* Otto voci vere del registro, dal roster del bundle. Il libro le legge
     tutte come "settled": la parrocchia pareggia, per chiunque sieda al
     tavolo la sera della lettura. Solo la riga nuova, in fondo, non lo è
     ancora. */
  var PARISH = [
    'Marta Cooper',
    'Hob Thresher',
    'Osric Coleman',
    'Bett Alder',
    'Corin Hayward',
    'Wynn Marsh',
    'Jorren Pike',
    'Rue Bank'
  ];
  var PARISH_STATUS = 'settled';
  var NEW_STATUS = 'entered';

  /* ------------------------------------------------------- misura testo -- */
  /* Interlettera gestita a mano, carattere per carattere: il letter-spacing
     nativo del canvas non è affidabile su tutti i telefoni, e le condivisioni
     partono soprattutto da lì. */
  function trackedWidth(ctx, text, tracking) {
    var w = 0;
    for (var i = 0; i < text.length; i++) {
      w += ctx.measureText(text[i]).width;
      if (i < text.length - 1) w += tracking;
    }
    return w;
  }

  function drawTracked(ctx, text, x, y, opts) {
    opts = opts || {};
    var tracking = opts.tracking || 0;
    var align = opts.align || 'left';
    var total = trackedWidth(ctx, text, tracking);
    var cx = x;
    if (align === 'center') cx = x - total / 2;
    else if (align === 'right') cx = x - total;

    var jitter = opts.jitter || 0;
    ctx.save();
    ctx.textAlign = 'left';
    for (var i = 0; i < text.length; i++) {
      if (jitter) {
        ctx.save();
        ctx.globalAlpha = ctx.globalAlpha * (1 - jitter / 2 + Math.random() * jitter);
        ctx.fillText(text[i], cx, y + (Math.random() - 0.5) * jitter * 3);
        ctx.restore();
      } else {
        ctx.fillText(text[i], cx, y);
      }
      cx += ctx.measureText(text[i]).width + tracking;
    }
    ctx.restore();
    return total;
  }

  /* Maiuscoletto sintetico per EB Garamond: IM Fell English SC lo ha già
     incorporato nel font (è quello il senso della sigla "SC"), ma Garamond
     no, e le etichette del registro (settled, entered, NAME, ACCOUNT) sono
     maiuscoletto per la Brand Bible. Ogni lettera minuscola diventa la sua
     maiuscola a una taglia ridotta, sulla stessa linea di base. */
  function scSpecs(text, size, smallScale) {
    var specs = [];
    for (var i = 0; i < text.length; i++) {
      var ch = text[i];
      var isLower = ch !== ch.toUpperCase() && ch === ch.toLowerCase();
      specs.push({ ch: ch.toUpperCase(), size: isLower ? Math.round(size * smallScale) : size });
    }
    return specs;
  }

  function measureSmallCaps(ctx, text, opts) {
    var family = opts.family, size = opts.size, smallScale = opts.smallScale || 0.72, tracking = opts.tracking || 0;
    var specs = scSpecs(text, size, smallScale);
    var total = 0;
    for (var i = 0; i < specs.length; i++) {
      ctx.font = specs[i].size + 'px ' + family;
      total += ctx.measureText(specs[i].ch).width;
      if (i < specs.length - 1) total += tracking;
    }
    return total;
  }

  function drawSmallCaps(ctx, text, x, y, opts) {
    var family = opts.family, size = opts.size, smallScale = opts.smallScale || 0.72, tracking = opts.tracking || 0;
    var align = opts.align || 'left';
    var specs = scSpecs(text, size, smallScale);
    var total = measureSmallCaps(ctx, text, opts);
    var cx = x;
    if (align === 'center') cx = x - total / 2;
    else if (align === 'right') cx = x - total;
    ctx.textAlign = 'left';
    for (var i = 0; i < specs.length; i++) {
      ctx.font = specs[i].size + 'px ' + family;
      ctx.fillText(specs[i].ch, cx, y);
      cx += ctx.measureText(specs[i].ch).width + tracking;
    }
    return total;
  }

  /* Un nome sta sempre bene: si restringe finche' non entra nello spazio
     disponibile (mai sotto min, che resta comunque sopra i 18px imposti
     dalla Brand Bible per IM Fell), e i nomi molto corti guadagnano
     interlettera per non restare persi nel rigo. */
  function trackingForName(len) {
    if (len <= 3) return 0.22;
    if (len <= 6) return 0.11;
    return 0.025;
  }

  function fitNameFont(ctx, text, family, maxSize, minSize, maxWidth) {
    var tracking = trackingForName(text.length);
    var size = maxSize;
    while (size > minSize) {
      ctx.font = size + 'px ' + family;
      if (trackedWidth(ctx, text, tracking * size) <= maxWidth) break;
      size -= 1;
    }
    ctx.font = size + 'px ' + family;
    return { size: size, tracking: tracking * size };
  }

  /* ------------------------------------------------------- motivi carta -- */

  var noiseTile = null;
  function getNoiseTile() {
    if (noiseTile) return noiseTile;
    var size = 96;
    var c = document.createElement('canvas');
    c.width = c.height = size;
    var cx = c.getContext('2d');
    if (cx) {
      var img = cx.createImageData(size, size);
      for (var i = 0; i < img.data.length; i += 4) {
        var v = 220 + Math.floor(Math.random() * 35);
        img.data[i] = v; img.data[i + 1] = v; img.data[i + 2] = v; img.data[i + 3] = 255;
      }
      cx.putImageData(img, 0, 0);
    }
    noiseTile = c;
    return c;
  }

  /* Filetto di lino: la stessa ricetta di .hh-grain (92 gradi, soot al 5%,
     passo di 6px), portata sul canvas invece che ripetuta in CSS. */
  function drawLinen(ctx, w, h) {
    ctx.save();
    ctx.strokeStyle = INK;
    ctx.globalAlpha = 0.045;
    ctx.lineWidth = 1;
    var tilt = Math.tan((92 - 90) * Math.PI / 180) * h;
    var step = 6;
    for (var x = -Math.abs(tilt) - step; x < w + step; x += step) {
      ctx.beginPath();
      ctx.moveTo(x, 0);
      ctx.lineTo(x + tilt, h);
      ctx.stroke();
    }
    ctx.restore();
  }

  function drawFoxing(ctx, w, h) {
    ctx.save();
    for (var s = 0; s < 24; s++) {
      var x = Math.random() * w, y = Math.random() * h, r = 10 + Math.random() * 34;
      var sx = 0.6 + Math.random() * 0.9, sy = 0.6 + Math.random() * 0.9, rot = Math.random() * Math.PI;
      ctx.save();
      ctx.translate(x, y); ctx.rotate(rot); ctx.scale(sx, sy);
      var g = ctx.createRadialGradient(0, 0, 0, 0, 0, r);
      var a = 0.05 + Math.random() * 0.08;
      g.addColorStop(0, PAPER_DEEP.replace('rgb', 'rgba').replace(')', ', ' + a + ')'));
      g.addColorStop(1, PAPER_DEEP.replace('rgb', 'rgba').replace(')', ', 0)'));
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(0, 0, r, 0, Math.PI * 2); ctx.fill();
      ctx.restore();
    }
    ctx.restore();
  }

  function drawVignette(ctx, w, h) {
    var g = ctx.createRadialGradient(w / 2, h * 0.46, h * 0.28, w / 2, h * 0.46, h * 0.74);
    g.addColorStop(0, 'rgba(22, 17, 12, 0)');
    g.addColorStop(1, 'rgba(22, 17, 12, 0.15)');
    ctx.save();
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);
    ctx.restore();
  }

  /* Passata finale: grana fine + qualche larga zona di inchiostrazione
     irregolare, in multiply, sopra a tutto (testo compreso), esattamente
     come la grana del sito sopra ogni pagina (body::after). */
  function drawAgingPass(ctx, w, h) {
    ctx.save();
    ctx.globalCompositeOperation = 'multiply';

    ctx.globalAlpha = 0.05;
    for (var b = 0; b < 4; b++) {
      var bx = Math.random() * w, by = Math.random() * h, br = 220 + Math.random() * 220;
      var bg = ctx.createRadialGradient(bx, by, 0, bx, by, br);
      bg.addColorStop(0, 'rgba(22, 17, 12, 0.55)');
      bg.addColorStop(1, 'rgba(22, 17, 12, 0)');
      ctx.fillStyle = bg;
      ctx.beginPath(); ctx.arc(bx, by, br, 0, Math.PI * 2); ctx.fill();
    }

    var pattern = ctx.createPattern(getNoiseTile(), 'repeat');
    if (pattern) {
      ctx.globalAlpha = 0.1;
      ctx.fillStyle = pattern;
      ctx.fillRect(0, 0, w, h);
    }
    ctx.restore();
  }

  /* La spiga della Brand Bible, incisa a mano sul canvas con le stesse
     coordinate relative dell'SVG di .hh-rule-wheat, solo scalate. */
  function drawWheatEar(ctx, cx, topY, k) {
    ctx.beginPath();
    ctx.moveTo(cx, topY); ctx.lineTo(cx, topY + 10 * k);
    ctx.moveTo(cx, topY + 2 * k); ctx.lineTo(cx - 3 * k, topY);
    ctx.moveTo(cx, topY + 2 * k); ctx.lineTo(cx + 3 * k, topY);
    ctx.moveTo(cx, topY + 5 * k); ctx.lineTo(cx - 3 * k, topY + 3 * k);
    ctx.moveTo(cx, topY + 5 * k); ctx.lineTo(cx + 3 * k, topY + 3 * k);
    ctx.moveTo(cx, topY + 8 * k); ctx.lineTo(cx - 3 * k, topY + 6 * k);
    ctx.moveTo(cx, topY + 8 * k); ctx.lineTo(cx + 3 * k, topY + 6 * k);
    ctx.stroke();
  }

  function drawWheatRule(ctx, left, right, topY) {
    var k = 1.25, unit = 28 * k;
    var width = right - left;
    var count = Math.max(2, Math.round(width / unit));
    var step = width / count;
    ctx.save();
    ctx.strokeStyle = WHEAT;
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1.3;
    for (var i = 0; i <= count; i++) drawWheatEar(ctx, left + i * step, topY, k);
    ctx.restore();
  }

  /* La tacca del bastone spaccato: un cancello di cinque (quattro segni
     verticali e un diagonale che li chiude) si legge "cinque". Due cancelli
     e un segno sciolto fanno undici, lo stesso numero della lettura di
     quest'anno scritta in fondo alla pagina: le due cose devono sempre
     tornare uguali. */
  function drawTallyEleven(ctx, x, y) {
    var barW = 3, barH = 27, pitch = 9, groupGap = 15;

    function gate(gx) {
      for (var i = 0; i < 4; i++) {
        var bx = gx + i * pitch;
        ctx.beginPath(); ctx.moveTo(bx, y); ctx.lineTo(bx, y + barH); ctx.stroke();
      }
      ctx.beginPath();
      ctx.moveTo(gx - 2, y + barH - 3);
      ctx.lineTo(gx + pitch * 3 + 2, y + 3);
      ctx.stroke();
      return pitch * 3 + barW;
    }

    ctx.save();
    ctx.strokeStyle = INK;
    ctx.globalAlpha = 1;
    ctx.lineWidth = barW;
    ctx.lineCap = 'butt';

    var w1 = gate(x);
    var x2 = x + w1 + groupGap;
    var w2 = gate(x2);
    var x3 = x2 + w2 + groupGap;
    ctx.beginPath(); ctx.moveTo(x3, y); ctx.lineTo(x3, y + barH); ctx.stroke();

    ctx.restore();
    return (x3 + barW) - x;
  }

  /* ------------------------------------------------------------- pagina -- */

  function draw(canvas, name) {
    canvas.width = LOGICAL_W * DPR;
    canvas.height = LOGICAL_H * DPR;
    var ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);

    var w = LOGICAL_W, h = LOGICAL_H;
    var CX = 92, CR = w - 92, MIDX = w / 2;

    /* --- la carta: fondo, ombreggiatura ai bordi, foxing, lino --------- */
    ctx.fillStyle = PAPER;
    ctx.fillRect(0, 0, w, h);
    drawVignette(ctx, w, h);
    drawFoxing(ctx, w, h);
    drawLinen(ctx, w, h);

    /* --- il filetto di riquadro, doppio, come sulle tavole ------------- */
    ctx.save();
    ctx.strokeStyle = INK;
    ctx.globalAlpha = 0.55; ctx.lineWidth = 3;
    ctx.strokeRect(44, 44, w - 88, h - 88);
    ctx.globalAlpha = 0.35; ctx.lineWidth = 1;
    ctx.strokeRect(58, 58, w - 116, h - 116);
    ctx.restore();

    /* --- intestazione ---------------------------------------------------*/
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = INK;
    ctx.globalAlpha = 1;
    ctx.font = '52px ' + F_DISPLAY;
    drawTracked(ctx, 'The Barn Book', MIDX, 148, { align: 'center', tracking: 0.03 * 52 });

    ctx.font = '23px ' + F_BODY;
    ctx.globalAlpha = 0.62;
    ctx.fillText('Tithewick, in the valley of the Wend', MIDX, 185);
    ctx.restore();

    drawWheatRule(ctx, CX + 30, CR - 30, 212);

    /* --- intestazione di colonna ----------------------------------------*/
    ctx.save();
    ctx.fillStyle = INK;
    ctx.globalAlpha = 0.6;
    drawSmallCaps(ctx, 'NAME', CX, 266, { family: F_BODY, size: 18, tracking: 0.09 * 18, align: 'left' });
    drawSmallCaps(ctx, 'ACCOUNT', CR, 266, { family: F_BODY, size: 18, tracking: 0.09 * 18, align: 'right' });
    ctx.restore();

    ctx.save();
    ctx.strokeStyle = INK;
    ctx.globalAlpha = 0.3;
    ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(CX, 280); ctx.lineTo(CR, 280); ctx.stroke();
    ctx.restore();

    /* --- le otto voci della parrocchia -----------------------------------
       Inchiostro leggermente irregolare: ogni lettera perde e riprende un
       filo di opacita', come una mano che ha scritto duecento righe prima
       di questa. La riga nuova, sotto, non ha questo tremito: e' appena
       stata scritta. */
    var rowY = 322, ROW_H = 60;
    var statusW = measureSmallCaps(ctx, PARISH_STATUS, { family: F_BODY, size: 19, smallScale: 0.74, tracking: 0.09 * 19 });
    var nameMax = (CR - CX) - statusW - 40;

    PARISH.forEach(function (parishName) {
      var fit = fitNameFont(ctx, parishName, F_DISPLAY, 29, 20, nameMax);
      ctx.save();
      ctx.fillStyle = INK;
      ctx.globalAlpha = 0.82;
      ctx.font = fit.size + 'px ' + F_DISPLAY;
      drawTracked(ctx, parishName, CX, rowY, { align: 'left', tracking: fit.tracking, jitter: 0.28 });
      ctx.restore();

      ctx.save();
      ctx.fillStyle = INK;
      ctx.globalAlpha = 0.48;
      drawSmallCaps(ctx, PARISH_STATUS, CR, rowY, { family: F_BODY, size: 19, smallScale: 0.74, tracking: 0.09 * 19, align: 'right' });
      ctx.restore();

      ctx.save();
      ctx.strokeStyle = INK;
      ctx.globalAlpha = 0.16;
      ctx.lineWidth = 1;
      ctx.beginPath(); ctx.moveTo(CX, rowY + 19); ctx.lineTo(CR, rowY + 19); ctx.stroke();
      ctx.restore();

      rowY += ROW_H;
    });

    /* --- la riga nuova, la tua -------------------------------------------*/
    var newDividerY = rowY + 22;
    ctx.save();
    ctx.strokeStyle = INK;
    ctx.globalAlpha = 0.55;
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(CX, newDividerY); ctx.lineTo(CR, newDividerY); ctx.stroke();
    ctx.restore();

    var newY = newDividerY + 58;
    var newStatusW = measureSmallCaps(ctx, NEW_STATUS, { family: F_BODY, size: 21, smallScale: 0.74, tracking: 0.09 * 21 });
    var newNameMax = (CR - CX) - newStatusW - 40;

    var nameFit = fitNameFont(ctx, name, F_DISPLAY, 46, 20, newNameMax);
    ctx.save();
    ctx.fillStyle = INK;
    ctx.globalAlpha = 1;
    ctx.font = nameFit.size + 'px ' + F_DISPLAY;
    ctx.save();
    ctx.beginPath();
    ctx.rect(CX, newY - nameFit.size * 1.15, newNameMax + 4, nameFit.size * 1.6);
    ctx.clip();
    drawTracked(ctx, name, CX, newY, { align: 'left', tracking: nameFit.tracking });
    ctx.restore();
    ctx.restore();

    ctx.save();
    ctx.fillStyle = INK;
    ctx.globalAlpha = 1;
    drawSmallCaps(ctx, NEW_STATUS, CR, newY, { family: F_BODY, size: 21, smallScale: 0.74, tracking: 0.09 * 21, align: 'right' });
    ctx.restore();

    drawTallyEleven(ctx, CX, newY + 30);

    /* --- chiusura ---------------------------------------------------------*/
    ctx.save();
    ctx.textAlign = 'center';
    ctx.fillStyle = INK;
    ctx.globalAlpha = 0.6;
    ctx.font = '25px ' + F_BODY;
    ctx.fillText('Second Bell. The reading this year is eleven.', MIDX, 1052);

    ctx.globalAlpha = 1;
    ctx.font = '31px ' + F_DISPLAY;
    drawTracked(ctx, 'The Hollow Harvest', MIDX, 1120, { align: 'center', tracking: 0.03 * 31 });
    ctx.restore();

    /* --- la carta invecchia per ultima, sopra a tutto --------------------*/
    drawAgingPass(ctx, w, h);
  }

  /* --------------------------------------------------------------- nome -- */

  function sanitiseName(raw) {
    return (raw || '').trim().replace(/\s+/g, ' ').slice(0, 28);
  }

  function slugify(raw) {
    var s = raw.normalize ? raw.normalize('NFD').replace(/[̀-ͯ]/g, '') : raw;
    s = s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
    return s.slice(0, 40);
  }

  /* --------------------------------------------------------------- init -- */

  function init(root) {
    var canvas = root.querySelector('[data-hh-ledger-canvas]');
    var input = root.querySelector('[data-hh-ledger-input]');
    var button = root.querySelector('[data-hh-ledger-write]');
    var after = root.querySelector('[data-hh-ledger-after]');
    var verdict = root.querySelector('[data-hh-ledger-verdict]');
    var link = root.querySelector('[data-hh-ledger-download]');
    if (!canvas || !input || !button) return;

    function safeDraw(name) {
      try {
        draw(canvas, name);
      } catch (err) {
        /* Il fondo CSS del canvas resta un foglio di carta anche se qui
           qualcosa si rompe: non lasciamo un riquadro vuoto sopra un
           errore silenzioso, solo un errore silenzioso. */
        if (window.console && console.warn) console.warn('hh-ledger', err);
        return;
      }
      try {
        if (link) {
          link.href = canvas.toDataURL('image/png');
          var slug = slugify(name);
          link.setAttribute('download', 'the-hollow-harvest-' + (slug || 'entry') + '.png');
        }
        canvas.setAttribute('aria-label', 'A page of the parish ledger. The newest entry reads: ' + name + ', entered.');
      } catch (err2) {
        /* toDataURL puo' fallire su un canvas "tainted": qui non succede
           mai (nessuna immagine esterna disegnata dentro), ma non deve
           comunque rompere il resto della pagina. */
      }
    }

    function ready(cb) {
      if (document.fonts && document.fonts.load) {
        Promise.all([
          document.fonts.load('52px "IM Fell English SC"'),
          document.fonts.load('23px "EB Garamond"')
        ]).then(cb).catch(cb);
      } else {
        cb();
      }
    }

    ready(function () { safeDraw('A stranger'); });

    function write() {
      var name = sanitiseName(input.value);
      if (!name) { input.focus(); return; }
      ready(function () {
        safeDraw(name);
        if (after) after.hidden = false;
        if (verdict) {
          verdict.textContent = 'Written down. In Tithewick that is the whole of it: ' +
            name + ' is now a name the village knows, and the book does not forget names.';
        }
      });
    }

    button.addEventListener('click', write);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); write(); }
    });
  }

  function boot() {
    document.querySelectorAll('[data-hh-ledger]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
